import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';

import { workflowLink } from './Checklist';
import DataStore from '../base/plumbing/DataStore';

import { ColourWarning } from '../base/components/Colour';
import { Card } from '../base/components/CardAccordion';
import PropControl from '../base/components/PropControl';
import { AdUnitTextEditor, LayoutControls } from './AdDesignExtraControls';
import KWorkflow from './KWorkflow';
import LinkOut from '../base/components/LinkOut';
import Icon from '../base/components/Icon';
import EditVideosForm from './EditVideosForm';
import ServerIO from '../plumbing/ServerIO';
import { assMatch } from '../base/utils/assert';
import { KAdFormat } from '../base/data/Advert';
import AdWysiwyg from './AdWysiwyg';
import AdPreviewCard from './AdPreviewCard';
import SocialPreviewCard from './SocialPreviewCard';

// NB a preview is added above this

function AdDesignControls({ advert, path }) {
	// Social mode flow is "splash video on platform --> adunit main screen" rather than "adunit main screen --> adunit end card"
	const isSocial = KAdFormat.social === advert.format;
	return (<>
		{isSocial? <SocialPreviewCard advert={advert} adid={advert.id} path={path} skipToEndCard={false} />
			: <AdWysiwyg advert={advert} adid={advert.id} path={path} skipToEndCard={false} />
		}
		<div>
			<LayoutControls advert={advert} path={[...path, 'advanced']} />

			<AdBranding advert={advert} path={path} />

			<EditVideosForm advert={advert} path={path} splash />
		</div>
	</>);
}


/**
 * 
 * @param {!String} url 
 * @returns PromiseValue(info)
 */
export const juice = url => {
	assMatch(url, String, "juice no url!");
	return DataStore.fetch(['misc', 'juice', url], () => {
		let pj = ServerIO.load(ServerIO.JUICE_ENDPOINT + "juice", { data: { url }, swallow: true });
		return pj;
	});
};


function AdBranding({ advert, path }) {
	// copy paste from BrandingEditor  -- then trimmed

	let b = advert.branding;
	if ( ! b) b = advert.branding = {};
	let bpath = path.concat('branding');

	const basePath = [...path, 'branding'];

	// Juice?
	if (advert.url && ! b.logo) { // go after more than the logo??
		let pvJuiceInfo = juice(advert.url);
		if (pvJuiceInfo.value) {
			let juiced = pvJuiceInfo.value;
			let jb = {
				logo: juiced.logo || juiced.publisher_logo,
				tw_url: juiced.twitter,
				fb_url: juiced.facebook,
				insta_url: juiced.instagram,
				yt_url: juiced.youtube,
				color: juiced.colors && juiced.colors[1],
				color2: juiced.colors && juiced.colors[3],
				backgroundColor: juiced.colors && juiced.colors[0]
			};
			// merge into b, but only where b is unset
			let merged = Object.assign({}, jb, b);
			Object.assign(b, merged);
		}
	}

	return (
		<Card title="Branding (logo etc) logo" logo={b && b.logo} >
			<Row>
				<Col sm="5">
					<PropControl label="Logo" type="imgUpload" item={b} prop="logo" path={bpath} version="standard" required cacheControls circleCrop
						help="Recommended format: .svg (which scales nicely to any size without pixelation). Otherwise, we recommend 256px square .png or .jpg.  Your image will be uploaded and preserved in its original state, as well as optimised for fast delivery. This optimised version of your image is what you will see on your rendered adunit."
					/>
				</Col>
				<Col sm="5">
					<PropControl label="Alternative logo" type="imgUpload" item={b} prop="altlogo" path={bpath} version="standard" required cacheControls circleCrop
						help="Recommended format: .svg (which scales nicely to any size without pixelation). Otherwise, we recommend 256px square .png or .jpg.  Your image will be uploaded and preserved in its original state, as well as optimised for fast delivery. This optimised version of your image is what you will see on your rendered adunit."
					/>
				</Col>
				<Col sm="5" className="advanced">
					<PropControl label="White Silhouette Logo" type="imgUpload" item={b} path={bpath} prop="logo_white" bg={(b && b.color) || "transparent"} version="standard" cacheControls />
				</Col>
				<Col sm="2">
					<PropControl label="Brand Colour" item={b} path={bpath} type="color" prop="color" />
				</Col>
			</Row>

			<ExtendedBrandingControls path={basePath} />

			<p>
				Landing page url: <LinkOut href={advert.url}>{advert.url || "Not set yet"}</LinkOut>
				{' '}<small><a className="ml-2" title="Go edit the landing page url" href={workflowLink(KWorkflow.Goal)}><Icon name="memo" /></a></small>
			</p>

		</Card>
	);
}


/**
 * Set background graphics and colours etc
 */
function ExtendedBrandingControls({ path }) {
	return <div>
		<Row>
			<Col xs="12" sm="6" md="3"><PropControl path={path} prop="backgroundImage" label="Background image (optional)" type="imgUpload" version="standard" cacheControls /></Col>
			<Col xs="12" sm="6" md="3"><PropControl path={path} prop="backgroundColor" label="Background colour" type="color" /></Col>
			<Col xs="12" sm="6" md="3"><PropControl path={path} prop="color" label="Text colour" type="color" /></Col>
			<Col xs="12" sm="6" md="3"><PropControl path={path} prop="color2" label="Highlight colour (e.g. timer, padlocks)" type="color" /></Col>
		</Row>
		<ColourWarning
			hex1={DataStore.getValue([...path, 'backgroundColor']) || '#F8EDD2'}
			hex2={DataStore.getValue([...path, 'color']) || '#000000'}
			message="The adunit text may be unreadable. Make sure that there is enough contrast between the background and text colours selected"
		/>
	</div>;
}


export default AdDesignControls;
export { ExtendedBrandingControls }; // EndCardDesignControls needs this when in social mode
